import React, { useState } from 'react'
import { IconErase, IconTime, Activity } from '@Knowledge-OTP/znk-ui-components'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment-timezone'
import useTranslation from '../../../../../../i18n/useTranslation'
import { showAlert } from '../../../../../../common/Alert/util'
import { Collapse } from 'reactstrap'
import useDeleteProcessInvoiceLater from './Model/useDeleteProcessInvoiceLater'
import useDeleteProcessMultipleInvoicesLater from './Model/useDeleteProcessMultipleInvoicesLater'

const formatDate = 'MM/DD/YYYY hh:mm a'

const ProgramProcessInvoiceLabel = (props) => {
  const { processDate, invoiceId, onDelete = () => { }, category = '', from='', to='' } = props
  const currentTimezone = useSelector((state) => state.user.timezone)
  const [processLaterDelete, setProcessLaterDelete] = useState(false)
  const dispatch = useDispatch()
  const { translate, replaceVariables } = useTranslation()
  const text = category !== '' ? replaceVariables(translate('payments.processpayment.programProcessInvoiceBulk.programFor'), {'CATEGORY': category , 'DATE': moment(processDate).tz(currentTimezone).format(formatDate) , 'FROM': moment(from).tz(currentTimezone).format('MM/DD/YYYY'), 'TO': moment(to).tz(currentTimezone).format('MM/DD/YYYY')}) : translate('payments.processpayment.programProcessInvoice.programFor') + ' ' + moment(processDate).tz(currentTimezone).format(formatDate)
  const onSuccessMutation = (res) => {
    setProcessLaterDelete(true)
    if (onDelete) onDelete()
  }
  const onErrorMutation = (err) => {
    showAlert({ text: err.toString(), status: 'error' }, dispatch)
  }
  const [deleteLater, { loading }] = useDeleteProcessInvoiceLater(onSuccessMutation)
  const [deleteMultipleInvoices, { loading: loadingMultipleInvoices }] = useDeleteProcessMultipleInvoicesLater(onSuccessMutation)
  const executeDeleteLater = () => {
    deleteLater({ variables: { invoiceId } }).then(() => {
      onSuccessMutation('Invoice deleted successfully')
    }).catch((err) => {
      onErrorMutation(err)
    })
  }
  const executeDeleteMultipleInvoices = () => {
    deleteMultipleInvoices({ variables: { invoiceIds: invoiceId } }).then(() => {
      onSuccessMutation('Invoices deleted successfully')
    }).catch((err) => {
      onErrorMutation(err)
    })
  }
  return (
    <Collapse isOpen={!processLaterDelete}>
      <div className='m-0 p-0 py-2 w-100 d-flex flex-row align-items-center justify-content-between'>
        <label className='pb-0 text-gray h45 text-truncate mb-0 w-100' style={{whiteSpace: 'normal', wordWrap: 'break-word'}}>
          <IconTime size={16} className='mr-2' />{text}
        </label>
        <div className='m-0 p-0 d-flex flex-row align-items-center justify-content-end'>
          {
            invoiceId && (
              <div
                onClick={() => {
                  if (!loading && !loadingMultipleInvoices) {
                    Array.isArray(invoiceId) ? executeDeleteMultipleInvoices() : executeDeleteLater()
                  }
                }}
                className='hover-icon'
              >
                {(loading || loadingMultipleInvoices) ? (
                  <Activity size={16} />
                ) : (
                  <IconErase size={16} className='text-error' />
                )}
              </div>
            )
          }
        </div>
      </div>
    </Collapse>
  )
}

export default ProgramProcessInvoiceLabel
